// Campus photo for /colleges/augusta-university: CC BY-SA 2.0, by Heather, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAugusta_State_University-The_Belltower_and_Allgood_Hall..jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/augusta-university/; credited under the photo.
const photo = {
    "slug": "augusta-university",
    "alt": "The bell tower in front of Allgood Hall on Augusta University's Summerville campus in Augusta, Georgia",
    "src": "/colleges/augusta-university/campus-1600.webp",
    "srcSmall": "/colleges/augusta-university/campus-800.webp",
    "srcMid": "/colleges/augusta-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/augusta-university/og.jpg",
    "title": "Augusta State University-The Belltower and Allgood Hall.",
    "author": "Heather",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAugusta_State_University-The_Belltower_and_Allgood_Hall..jpg",
    "read": "2026-10-01"
};

export default photo;
